import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import { useInvalidatingMutation } from '../utils/mutation';

export interface ProjectPassword {
  id: string;
  password: string;
  description?: string;
  projectId: string;
}

export function useProjectPasswords(projectId: string) {
  return useQuery<ProjectPassword[]>({
    queryKey: ['projectPasswords', projectId],
    queryFn: () => api.get<ProjectPassword[]>(`/project/${projectId}/password`),
    enabled: !!projectId,
  });
}

export function useCreatePassword(projectId: string) {
  return useInvalidatingMutation(
    ['projectPasswords', projectId],
    (data: { password: string; description?: string }) =>
      api.post<ProjectPassword>(`/project/${projectId}/password`, data)
  );
}

export function useDeletePassword(projectId: string) {
  // Errors surface via the global handler.
  return useInvalidatingMutation(
    ['projectPasswords', projectId],
    (passwordId: string) => api.delete(`/project/${projectId}/password/${passwordId}`),
  );
}
